module.exports = __webpack_public_path__ + "static/classic-white-897cf7e5305964fb645f474f3000dc36.svg";